import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import {
  isVoucherFaceValueUnavailable,
  isError as isErrorSelector
} from '@epi-selectors/voucherReorder';
import { useGetMetadataQuery } from '@epi-api/companyMetadata';
import { goToPage } from '@epi-actions/navigation';

import { join } from '../helpers/UrlHelpers';
import { reorderData as reorderDataLoadingSelector } from '../selectors/loading';
import { routerPaths } from '../constants/routerPaths';
import { VoucherReOrder } from '../containers/VoucherOrder/VoucherReOrder';
import * as voucherReorderActions from '../actions/voucherReorder';

import { LoadingData } from './LoadingData';
import { ConditionalRedirect } from './ConditionalRedirect';
import { LoadingSpinner } from 'edenred-ui';

interface ReorderRouteProps {
  match: {
    params: {
      orderId: string;
    };
  };
  path: string;
}

export const ReorderRoute: React.FC<ReorderRouteProps> = ({ path, match }) => {
  const { orderId } = match.params;
  const { data: companyMetadata, isSuccess, isLoading } = useGetMetadataQuery();
  const dispatch = useDispatch();

  useEffect(() => {
    if (isSuccess && !companyMetadata?.orderVouchersEnabled) {
      dispatch(goToPage(routerPaths.home));
    }
  }, [isSuccess, companyMetadata]);

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (!companyMetadata?.orderVouchersEnabled) {
    return null;
  }

  return (
    <LoadingData
      loadAction={() => voucherReorderActions.loadReorderData(orderId)}
      loadingSelector={state => reorderDataLoadingSelector(state, orderId)}
      errorSelector={state => isErrorSelector(state)}
    >
      <ConditionalRedirect
        redirect={`${join(path, routerPaths.voucherReorderEditAmount)}`}
        redirectSelector={isVoucherFaceValueUnavailable}
      >
        <VoucherReOrder />
      </ConditionalRedirect>
    </LoadingData>
  );
};
